import * as React from 'react';
import { I18n } from 'react-i18next';

interface IProps {
  ns: string;
  tk: string;
}

export const T = ({ ns, tk }: IProps) => <I18n ns={[ns]}>{t => t(tk)}</I18n>;
